/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StepRecipeDeleteModalMutationVariables = {|
  id: string
|};
export type StepRecipeDeleteModalMutationResponse = {|
  +recipeStepDelete: ?{|
    +deleted: ?boolean
  |}
|};
export type StepRecipeDeleteModalMutation = {|
  variables: StepRecipeDeleteModalMutationVariables,
  response: StepRecipeDeleteModalMutationResponse,
|};
*/


/*
mutation StepRecipeDeleteModalMutation(
  $id: ID!
) {
  recipeStepDelete(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeStepDeletePayload",
    "kind": "LinkedField",
    "name": "recipeStepDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StepRecipeDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StepRecipeDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "StepRecipeDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation StepRecipeDeleteModalMutation(\n  $id: ID!\n) {\n  recipeStepDelete(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6fd31aa9ed886f9962fbaedce780a48b';

module.exports = node;
